const VerifiedContent = [
    {
        icon: 'circle-checkmark',
        text: '<span class="semi-bold">A verified adviser</span> - we have checked the FCA register',
    },
    {
        icon: 'circle-checkmark',
        text: '<span class="semi-bold">Positively reviewed</span> by genuine clients',
    },
    {
        icon: 'circle-checkmark',
        text: '<span class="semi-bold">Easily accessible</span> - face to face or over the phone',
    },
];

export default VerifiedContent;
